import axios, { AxiosError, AxiosHeaders } from 'axios'
import { redirect } from 'react-router-dom'

export const baseUrl = process.env.REACT_APP_BASE_URL ?? ''

export const getAccessToken = () =>
  //   return localStorage.getItem('token')
  'eGxycy1zZXJ2aWNlOlJGY2tFaGpqVDlWRnlzRXlhTXda'

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
    // Tells the backend this is the portal, so a 401 comes back without the
    // WWW-Authenticate header that makes the browser pop up a login box.
    'X-Requested-With': 'XMLHttpRequest'
  }
})

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAccessToken()

    if (config.headers.Authorization !== false && token) {
      ;(config.headers as AxiosHeaders).set(
        'Authorization',
        token ? `Basic ${token}` : ''
      )
    } else {
      // eslint-disable-next-line no-param-reassign
      delete config.headers.Authorization
    }

    return config
  },
  (error: AxiosError) => Promise.reject(error)
)

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const status = error.response?.status

    if (status === 403) {
      localStorage.clear()
      return redirect('/auth')
    }
    throw error
  }
)

export default axiosInstance
